export default {
    listagem: {
        titulo_pagina: 'Integration Helper Classes',
        novo: 'Create new helper class',
        table: {
            empty: 'No helper class found',
            nome: 'Name',
            classe: 'Class',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Helper Class',
            editar: 'Edit Helper Class'
        },
        fields: {
            nome: {
                label: 'Name',
                description: 'Helper Class Name'
            },
            classe: {
                label: 'Class',
                description: 'Class helper'
            },
            status: {
                label: 'Status',
                description: 'Active or inactive status'
            },
            botao_salvar : 'Save helper'
        },
        create: {
            success: 'Helper class successfully created!',
            error: 'Error creating helper class!'
        },
        update: {
            success: 'Helper class successfully edited!',
            error: 'Error editing helper class!'
        }
    }
}
